import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { useId, useState } from 'react';
import { ThreadText } from './ThreadText';

/**
 * Citazione dell'email precedente tolta da una replica (#42): nascosta, si apre a richiesta con
 * «Mostra testo citato». Testo semplice come il resto del thread (DEC-008).
 */
export function QuotedText({ text }: { text: string }) {
  const [open, setOpen] = useState(false);
  const id = useId();
  return (
    <Box>
      <Button size="small" aria-expanded={open} aria-controls={id} onClick={() => setOpen((value) => !value)}>
        {open ? 'Nascondi testo citato' : 'Mostra testo citato'}
      </Button>
      {open && (
        <Box id={id} sx={{ mt: 1, pl: 2, borderLeft: 2, borderColor: 'grey.600', color: 'text.secondary' }}>
          <ThreadText text={text} />
        </Box>
      )}
    </Box>
  );
}
